import { Box, useTheme } from '@mui/material'
import AuthorizationProvider from 'authorization/AuthorizationProvider'
import { Outlet } from 'react-router-dom'
import React from 'react'
import apiClient from '../services/api'
import { KuknosServer } from '../services/kuknosServer'

function AuthLayout() {
    const currentTheme = useTheme()

    return (
        <AuthorizationProvider
            providerValue={{
                theme: currentTheme,
                axiosInstance: apiClient,
                blockchainServer: KuknosServer,
            }}
        >
            <Box
                sx={{
                    height: '100vh',
                }}
            >
                <Outlet />
            </Box>
        </AuthorizationProvider>
    )

}

export default AuthLayout;
